export default __webpack_public_path__ + "static/media/Ethnicity.18072179.svg";